import React from 'react';
import { OnlineProduct } from '../../../../../../../../packages/apis/src/shopify/types/OnlineProduct';
import { ProductCartData, ShopifyProduct } from '../../../../api/shopify/types';
import { CTAButton } from './CTAButton';
import { styles } from './CallToAction.css';
import WishlistButtonPDP from './wishlist/WishlistButtonPDP';
import { CompareButtonPDP } from '@jbhi-fi/components/src/ProductCompare';
import { useProductCompare } from '@jbhi-fi/components/src/ProductCompare';
import { getStoreCurrency } from '../../../../utils/shopify/getStoreCurrency';
import { useIdPrefix } from '@jbhi-fi/components/src/IdPrefix';

interface CallToActionProps {
  shouldCtaRender: boolean;
  variantAvailable: boolean;
  buttonType: string;
  product: ShopifyProduct;
  isDigital: boolean;
  setIsCtaVisible: (value: boolean) => void;
  productMetafields: OnlineProduct;
  productCartData: ProductCartData;
  sku: number;
  variantSku: string | undefined;
  priceTagWidth: number;
  gtmData: any;
  trackingListName?: string | null;
  productCategoryHierarchy?: Array<string>;
  quantity: number;
  checkAvailabilityAction?: () => void;
}

export const CallToAction = ({
  shouldCtaRender,
  variantAvailable,
  buttonType,
  product,
  isDigital,
  setIsCtaVisible,
  productMetafields,
  productCartData,
  sku,
  priceTagWidth,
  variantSku,
  gtmData,
  trackingListName,
  productCategoryHierarchy,
  quantity,
  checkAvailabilityAction,
}: CallToActionProps) => {
  const { shouldShowCompare, isAddedToCompare, compareHandleClick } = useProductCompare();
  const showCompareButton = shouldShowCompare(productMetafields?.ProductGroup?.Id);
  const skuString = String(sku);
  const elementIds = {
    wrapper: useIdPrefix('call-to-action-wrapper'),
    innerContainer: useIdPrefix('call-to-action-inner-container'),
  };

  return (
    <div className={styles.container({ showCompareButton })} id={elementIds.wrapper}>
      {shouldCtaRender ? (
        <CTAButton
          className={styles.title}
          buttonType={buttonType}
          variantAvailable={variantAvailable}
          productCartData={productCartData}
          product={product}
          gtmProduct={window?.gtm?.product ?? product}
          isDigital={isDigital}
          setIsCtaVisible={setIsCtaVisible}
          trackButton
          trackingListName={trackingListName}
          productCategoryHierarchy={productCategoryHierarchy}
          quantity={quantity || 1}
          checkAvailabilityAction={checkAvailabilityAction}
        />
      ) : null}
      <div className={styles.innerContainer} id={elementIds.innerContainer}>
        {showCompareButton ? (
          <CompareButtonPDP
            isAddedToCompare={isAddedToCompare(skuString)}
            handleClick={() =>
              compareHandleClick(skuString, product.featured_image, {
                trackingDescriptor: {
                  page: 'PDP',
                  currency: getStoreCurrency(),
                  ecommerceExtraProps: {
                    list: 'collection',
                  },
                },
                gtm: gtmData,
              })
            }
          />
        ) : null}
        <WishlistButtonPDP
          className={styles.wishlistButton}
          productCartData={productCartData}
          product={product}
          gtmData={gtmData}
          sku={sku}
          onlineValue={productMetafields}
          variantAvailable={variantAvailable}
          buttonType={buttonType}
          isDigital={isDigital}
          priceTagWidth={priceTagWidth}
          variantSku={variantSku}
          shouldShowCompare={showCompareButton}
        />
      </div>
    </div>
  );
};
